module.exports = __webpack_public_path__ + "img/2025-08-16c_3.13a2a1f0.jpg";